import { ReferenceAsset } from "domains/inference/interfaces/InferenceGenerator";
import { GetModelsByModelIdApiResponse } from "infra/api/generated/api";

export type Form = Record<
  string,
  | string
  | number
  | boolean
  | string[]
  | number[]
  | ReferenceAsset
  | ReferenceAsset[]
  | undefined
>;

export type Body = Record<
  string,
  string | number | boolean | string[] | number[] | undefined
>;

export type Input = NonNullable<
  GetModelsByModelIdApiResponse["model"]["inputs"]
>[number] & {
  isWithPasteImage?: boolean;
};

export const GENERATE_TRIGGER_KEY = "generateTrigger";
